
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Vue from "vue"

export default Vue.extend({
  name: "ProgressBenefitCard",
  emits: ["click"],
  props: {
    title: { type: String, required: true },
    progress: { type: Number, default: 0 },
    unlocked: { type: Boolean, default: false },
    icon: { type: String, default: "mdi-medal" },
    statusLabel: { type: String, default: "" },
  },
  computed: {
    hasPrimaryAccent(): boolean {
      return this.unlocked || this.progress > 0
    },
    inProgress(): boolean {
      return !this.unlocked && this.progress > 0
    },
    showStatusChip(): boolean {
      return Boolean(this.statusLabel) && !this.inProgress
    },
    accentColor(): string {
      return this.hasPrimaryAccent ? "primary" : "grey lighten-1"
    },
    chipColor(): string {
      if (this.unlocked) {
        return "primary"
      }
      return "grey lighten-2"
    },
    chipTextColor(): string | undefined {
      if (this.unlocked) {
        return "white"
      }
      return undefined
    },
  },
})
